import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import { buildErrorMessageForName } from "@gettactic/helpers/src/hook-form/buildErrorMessageForName";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { FileUploadInput } from "./FileUploadInput";
import { HookFormFileUploadInputProps } from "./FileUploadInput.types";

export const HookFormFileUploadInput = <T extends FieldValues>(
  props: HookFormFileUploadInputProps<T>
): React.ReactElement => {
  const {
    form,
    name,
    rules,
    generateUpload,
    label,
    isRequired,
    description,
    disabled
  } = props;

  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({ form, name, rules, isRequired })}
      render={({ field, fieldState }) => (
        <FileUploadInput
          value={field.value}
          onChange={field.onChange}
          generateUpload={generateUpload}
          label={label}
          isRequired={isRequired}
          description={description}
          disabled={disabled}
          error={
            fieldState.error?.message ||
            buildErrorMessageForName(form, name) ||
            undefined
          }
        />
      )}
    />
  );
};
